import { getGlobalValue, setGlobalValue } from '../../../utils/global-storage';
import { isSelectStaffing } from '../../../api/dashboards-api';

const STORED_FILTERS = 'hutrics.filters.stored';
const STORED_OPENING_TYPE = 'hutrics.filters.opening.stored';

export const STAFFING_ONSITE_OPENING = 'onsite';
export const STAFFING_REMOTE_OPENING = 'remote';
export const LEADERSHIP_OPENING = 'leadership';

const allItemsSelected = (items) => {
  let allSelected = true;
  for (const item of items) {
    if (!item.selected) {
      allSelected = false;
      break;
    }
  }

  return allSelected;
};
const saveStoredFilters = (storedFilters) => {
  setGlobalValue(STORED_FILTERS, storedFilters);
};

const getStoredFilters = () => {
  let storedFilters = getGlobalValue(STORED_FILTERS);
  if (!storedFilters) {
    storedFilters = {};
    saveStoredFilters(storedFilters);
  }
  return storedFilters;
};

export const setOpeningType = (staffingLocation) => {
  setGlobalValue(STORED_OPENING_TYPE, staffingLocation);
};

export const getOpeningType = () => {
  const storedStaffingLocation = getGlobalValue(STORED_OPENING_TYPE);
  if (!storedStaffingLocation && isSelectStaffing()) {
    setOpeningType(LEADERSHIP_OPENING);
    return LEADERSHIP_OPENING;
  } else {
    return storedStaffingLocation;
  }
};

const sortItems = (items) => {
  items.sort((a, b) => {
    const lcA = a.value.toLowerCase();
    const lcB = b.value.toLowerCase();
    if (lcA > lcB) {
      return 1;
    } else if (lcA < lcB) {
      return -1;
    }
    return 0;
  });
};

export const getFilterKeys = () => {
  const filters = getStoredFilters();
  const keys = Object.keys(filters);
  if (keys.length > 0) {
    keys.sort((a, b) => {
      const posA = filters[a].position;
      const posB = filters[b].position;
      if (posA > posB) {
        return 1;
      } else if (posA < posB) {
        return -1;
      }
      return 0;
    });

    return keys;
  }
};

export const filtersExist = () => {
  return Object.keys(getStoredFilters()).length > 0;
};

export const areFiltersInUse = () => {
  if (!filtersExist()) {
    return false;
  }
  for (const entry of Object.entries(getStoredFilters())) {
    if (!entry[1].allSelected) {
      return true;
    }
  }

  return false;
};

export const getStoredFilter = (filterKey) => {
  return getStoredFilters()[filterKey];
};

export const setStoredFilter = (
  filterKey,
  displayName,
  displayPosition,
  distinctValues,
  items,
  parentKey = undefined,
  parentRelationships = undefined
) => {
  const storedFilters = getStoredFilters();
  sortItems(items);
  storedFilters[filterKey] = {
    displayName,
    position: displayPosition,
    distinctValues: [...distinctValues],
    items: [...items],
    allSelected: allItemsSelected(items),
    parentKey,
    parentRelationships,
    set: {
      items: [...items],
      distinctValues: [...distinctValues],
    },
  };
  saveStoredFilters(storedFilters);
};

const filterChild = (parentKey, parentFilter, storedFilters) => {
  for (const entry of Object.entries(storedFilters)) {
    const storedFilter = entry[1];
    const updatedItems = [];
    const updatedDistinctValues = [];
    if (storedFilter.parentKey === parentKey) {
      parentFilter.items.forEach((item) => {
        if (item.selected) {
          const itemValues = storedFilter.parentRelationships[item.lcValue];
          if (itemValues) {
            itemValues.forEach((value) => {
              for (const childItem of storedFilter.set.items) {
                if (childItem.lcValue === value) {
                  if (!updatedDistinctValues.includes(childItem.value)) {
                    updatedItems.push({ ...childItem, selected: true });
                    updatedDistinctValues.push(childItem.value);
                  }
                }
              }
            });

            sortItems(updatedItems);
            storedFilter.items = updatedItems;
            storedFilter.distinctValues = updatedDistinctValues;
            storedFilter.allSelected = allItemsSelected(updatedItems);
          }
        }
      });
      filterChild(entry[0], storedFilter, storedFilters);
      break;
    }
  }
};

export const updateStoredFilterItems = (filterKey, items) => {
  const storedFilters = getStoredFilters();
  sortItems(items);
  storedFilters[filterKey] = {
    ...storedFilters[filterKey],
    items: [...items],
    allSelected: allItemsSelected(items),
  };
  filterChild(filterKey, storedFilters[filterKey], storedFilters);
  saveStoredFilters(storedFilters);
};
